import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';
import * as shortId from 'shortid';

class WebsocketService {
    static ws = undefined;
    static subscriptions = {};
    static getEndpoint = () => {
        let appContext = new AppContext();

        let token = appContext.getToken();
        let config = appContext.getConfig();
        return fetchAPI({
            token: token,
            url: `${config.WebsocketService}endpoint`,
            method: 'GET',
            body: undefined,
        });
    };

    static async connectSocket() {
        if (WebsocketService.ws !== undefined) {
            if (WebsocketService.ws.readyState !== WebSocket.OPEN && WebsocketService.ws.readyState !== WebSocket.CONNECTING) {
                // Close old instance of ws
                let tws = WebsocketService.ws;
                tws.close();

                WebsocketService.ws = undefined;
            }
        }
        if (WebsocketService.ws === undefined) {
            let appContext = new AppContext();
            let token = appContext.getToken();
            const endpoint = (await WebsocketService.getEndpoint()).endpoint;
            // WARN: Pseudoatomic, not completely thread safe
            WebsocketService.ws = WebsocketService.ws ? WebsocketService.ws : new WebSocket(`${endpoint}?token=${token}`);
            WebsocketService.ws.onopen = WebsocketService.onOpen;
            WebsocketService.ws.onmessage = WebsocketService.onMessage;
            WebsocketService.ws.onclose = WebsocketService.onClose;
        }
    }

    static subscribe = async (onMessage, message) => {
        await WebsocketService.connectSocket();

        const subId = shortId();
        WebsocketService.subscriptions[subId] = { message, onMessage };
        return subId;
    };

    static unsubscribe = async (subId) => {
        if (WebsocketService.subscriptions[subId]) {
            delete WebsocketService.subscriptions[subId];
        }
    };

    static onOpen() {
        //console.log('Websocket open');
    }

    static onMessage(evt) {
        try {
            for (let subscription of Object.values(WebsocketService.subscriptions)) {
                const data = JSON.parse(evt.data);
                if (subscription.message === data.message) {
                    subscription.onMessage(data);
                }
            }
        } catch (err) {
            console.log(err);
            /* TODO: Log this*/
        }
    }

    static onClose() {
        // Reconnect
        setTimeout(WebsocketService.connectSocket, 1000);
    }
}

export default WebsocketService;
